// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__slVV4","title":"Container_title__9yjSi"};